import script from "./Content.vue?vue&type=script&lang=ts&setup=true"
export * from "./Content.vue?vue&type=script&lang=ts&setup=true"

import "./Content.vue?vue&type=style&index=0&id=f6243de0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6243de0"]])

export default __exports__